import { Injectable } from '@angular/core';
import { ProgramFilter } from 'src/app/shared/enums/program-filter.enum';
import { TokenStorageService } from './token-storage.service';

@Injectable()
export class GraphService {
  constructor(private readonly tokenStorage: TokenStorageService) {}

  public hasComparisonPermission(): boolean {
    return (
      this.tokenStorage.userInfo.IsCoordinator ||
      this.tokenStorage.userInfo.IsSupervisor ||
      this.tokenStorage.userInfo.IsSiteAdmin ||
      this.tokenStorage.userInfo.IsObserver ||
      this.tokenStorage.userInfo.IsSysAdmin
    );
  }

  public hasReportsIndexViewPermission(): boolean {
    return (
      this.tokenStorage.userInfo.IsCoordinator ||
      this.tokenStorage.userInfo.IsSupervisor ||
      this.tokenStorage.userInfo.IsSiteAdmin ||
      this.tokenStorage.userInfo.IsObserver ||
      this.tokenStorage.userInfo.IsSysAdmin
    );
  }

  public hasPeReportsIndexViewPermission(): boolean {
    return (
      this.tokenStorage.userInfo.IsCoordinator ||
      this.tokenStorage.userInfo.IsSiteAdmin ||
      this.tokenStorage.userInfo.IsObserver ||
      this.tokenStorage.userInfo.IsSysAdmin
    );
  }

  public hasPeComparisonPermission(): boolean {
    return (
      this.tokenStorage.userInfo.IsCoordinator ||
      this.tokenStorage.userInfo.IsSiteAdmin ||
      this.tokenStorage.userInfo.IsObserver ||
      this.tokenStorage.userInfo.IsSysAdmin
    );
  }

  public isLocationFilterDisabled(): boolean {
    return (
      !this.tokenStorage.userInfo.IsSiteAdmin &&
      !this.tokenStorage.userInfo.IsObserver &&
      ((this.tokenStorage.userInfo.IsSupervisor &&
        this.tokenStorage.userInfo.CurrentProgram.FilterSupervisorsByLocation ===
          ProgramFilter.AccessAndNotifications) ||
        (this.tokenStorage.userInfo.IsTrainer &&
          this.tokenStorage.userInfo.CurrentProgram.FilterTrainersByLocation === ProgramFilter.AccessAndNotifications))
    );
  }

  public isShiftFilterDisabled(): boolean {
    return (
      !this.tokenStorage.userInfo.IsSiteAdmin &&
      !this.tokenStorage.userInfo.IsObserver &&
      ((this.tokenStorage.userInfo.IsSupervisor &&
        this.tokenStorage.userInfo.CurrentProgram.FilterSupervisorsByShift === ProgramFilter.AccessAndNotifications) ||
        (this.tokenStorage.userInfo.IsTrainer &&
          this.tokenStorage.userInfo.CurrentProgram.FilterTrainersByShift === ProgramFilter.AccessAndNotifications))
    );
  }
}
